var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUrgent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 32,
    viewBox: "0 0 34 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9995 21.8413C16.049 21.8413 15.2522 22.6381 15.2522 23.5886C15.2522 24.5391 16.049 25.3359 16.9995 25.3359C17.9151 25.3359 18.7468 24.5392 18.7049 23.6306C18.7468 22.6311 17.957 21.8413 16.9995 21.8413Z",
    fill: "#CD0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1726 28.0338C34.27 26.1397 34.2769 23.8822 33.1866 21.9951L22.2415 3.04031C21.1582 1.13225 19.2012 0 17.0066 0C14.8119 0 12.855 1.13924 11.7716 3.03332L0.812531 22.0091C-0.277788 23.9171 -0.270799 26.1886 0.833499 28.0827C1.92382 29.9558 3.87381 31.0811 6.05445 31.0811H27.9167C30.1044 31.0811 32.0683 29.9418 33.1726 28.0338ZM30.7963 26.6639C30.1882 27.7123 29.1119 28.3343 27.9098 28.3343H6.04746C4.85929 28.3343 3.78994 27.7263 3.19586 26.6988C2.59478 25.6574 2.58779 24.4134 3.18887 23.365L14.148 4.39622C14.7421 3.35483 15.8044 2.73978 17.0066 2.73978C18.2017 2.73978 19.2711 3.36182 19.8652 4.40321L30.8173 23.372C31.4044 24.3924 31.3974 25.6225 30.7963 26.6639Z",
    fill: "#CD0000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5662 9.57521C15.7345 9.81284 15.2173 10.5677 15.2173 11.4833C15.2592 12.0354 15.2942 12.5946 15.3361 13.1467C15.4549 15.2505 15.5737 17.3123 15.6926 19.416C15.7345 20.1289 16.2866 20.6461 16.9995 20.6461C17.7124 20.6461 18.2716 20.094 18.3065 19.3741C18.3065 18.9408 18.3065 18.5424 18.3485 18.1021C18.4253 16.7531 18.5092 15.4042 18.5861 14.0553C18.628 13.1816 18.7049 12.308 18.7468 11.4343C18.7468 11.1198 18.7049 10.8403 18.5861 10.5607C18.2296 9.7779 17.3979 9.37951 16.5662 9.57521Z",
    fill: "#CD0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUrgent);
export default __webpack_public_path__ + "static/media/urgent.458f83b6171b29a8c9d3934b970f6c15.svg";
export { ForwardRef as ReactComponent };